import type { QueryClient } from '@tanstack/react-query';

export const OPEN_INVOICES_QUERY_ROOT = 'open-invoices';

export const invalidateOpenInvoices = (queryClient: QueryClient, clientId: string | null): Promise<void> =>
  queryClient.invalidateQueries({ queryKey: [OPEN_INVOICES_QUERY_ROOT, clientId], refetchType: 'all' });
